import * as React from 'react';

import {colors} from 'shells/colors/colors';
import {AiSparkleNewIcon} from 'shells/icon/svg/ai-sparkle-new-icon';
import {Stack} from 'shells/layout/stack/stack';
import {Body} from 'shells/typography/body';

import {analyticsClient} from '../../../analytics-client';

import {ChatPreviewRoot} from '../../chat-preview/chat-preview-root';
import type {PreviewType} from '../../chat-preview/consts';

import {clearChatPreviewSessionKey} from './test/helpers';

import styles from './chat-preview-wrapper.module.css';

type Props = {
    previewWebsiteUrl: string;
    previewType: PreviewType;
    embedScript: string;
    instanceId: string | number;
    canEmbedInIframe?: boolean | null | undefined;
    isOnboarding?: boolean;
    isViaPublicUrl?: boolean;
    isDevelopment?: boolean;
};

export function ChatPreviewWrapper(props: Props) {
    React.useEffect(() => {
        clearChatPreviewSessionKey(props.instanceId);
    }, [props.instanceId]);

    React.useEffect(() => {
        analyticsClient.track(analyticsClient.EVENTS.TRACK_CHATBOT_PREVIEW_VIEWED, {
            is_onboarding: props.isOnboarding || false,
            page_allowed_iframe: props.canEmbedInIframe,
            is_via_public_url: props.isViaPublicUrl || false,
        });
    }, [props.isOnboarding, props.canEmbedInIframe, props.isViaPublicUrl]);

    return (
        <div className={styles['interactive-preview-wrapper']}>
            <div className='flex flex-dir-col gap-12 py-4'>
                <Stack spacing={12} isHorizontal={true} alignItems='center' justifyContent='center'>
                    <Body isBold={true} color='dark'>
                        This is a preview of your website:
                    </Body>
                    <Stack spacing={8} isHorizontal={true} alignItems='center'>
                        {/* @ts-expect-error */}
                        <AiSparkleNewIcon color={colors.plum} size={16} wrapWithDiv={false} />
                        <Body isBold={true} color='plum'>
                            Powered by Nutshell AI
                        </Body>
                    </Stack>
                </Stack>
                {!props.canEmbedInIframe && (
                    <Body isBold={true} color='plum' textAlign='center'>
                        Your website's content is not previewable. Don't worry— we've still crawled
                        your website to train your chatbot!
                    </Body>
                )}
            </div>
            <div className='br-y-16 background-white full-width full-height flex align-center justify-center overflow-hidden'>
                <div className='full-width full-height flex'>
                    <ChatPreviewRoot
                        previewWebsiteUrl={props.previewWebsiteUrl}
                        embedScript={props.embedScript}
                        instanceId={props.instanceId}
                        previewType={props.previewType}
                        canEmbedInIframe={props.canEmbedInIframe}
                        isDevelopment={props.isDevelopment}
                    />
                </div>
            </div>
        </div>
    );
}
